<script setup>
import PricingTierRow from "@/components/website/agency/partials/ui/PricingTierRow.vue";

const emit = defineEmits(['back']);

defineProps({
  product: {
    type: Object,
    required: true,
  },
  recommended: {
    type: Boolean,
    default: false,
  },
  addon: {
    type: [Object, null],
    default: null,
  }
});
</script>

<template>
  <div
    class="tw-border-2 tw-flex tw-flex-col tw-gap-y-2 tw-p-3 tw-w-full"
    :class="[recommended ? 'tw-border-primary tw-rounded-b-2xl tw-bg-primary-100/25' : 'tw-border-neutral-300 tw-rounded-2xl tw-mt-12']"
  >
    <div
      class="tw-border tw-border-primary tw-rounded-lg hover:tw-cursor-pointer tw-p-2 tw-flex tw-self-end hover:tw-bg-primary hover:tw-border-white tw-text-primary hover:tw-text-white"
      @click="emit('back')"
    >
      <svg-vue
        icon="icons/arrow-right"
        class="tw-h-6 tw-w-6 tw-stroke-2 tw-rotate-180"
      />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-8 tw-p-6 tw-text-neutral-900">
      <span class="tw-text-3xl">Pricing Tiers</span>

      <div class="tw-grid tw-grid-cols-4">
        <div class="tw-col-start-1 tw-col-span-2 tw-py-4">
          <span class="tw-text-xxs">Tier (Total Websites in Account)</span>
        </div>
        <div class="tw-col-span-1 tw-py-4">
          <span
            v-if="addon"
            class="tw-text-xxs"
          >
            Addon Price
          </span>
        </div>
        <div class="tw-py-4 tw-flex tw-justify-end tw-items-center">
          <span class="tw-text-xxs">Price Per Site</span>
        </div>

        <PricingTierRow
          v-for="(tier, index) in product.tiers"
          :key="index"
          :label="tier.label"
          :text="tier.amount"
          :price="tier.price"
          :price-inc-vat="tier.priceIncVat"
          :addon-price="product.addon?.price"
          :addon-price-inc-vat="product.addon?.priceIncVat"
          :complete="product.tier > tier.tier"
          :active="product.tier === tier.tier"
          :last-element="index === product.tiers.length - 1"
        />
      </div>

      <span class="tw-text-xxs tw-text-neutral">
        *Prices exclude any websites added during a Hike sale period
      </span>
    </div>
  </div>
</template>
